define('models/search',[
  "backbone"
], function (Backbone) {
  "use strict";

  return Backbone.Model.extend({
    defaults: {
      offset: 0,
      maxResults: 20
    },

    increaseOffset: function () {
      return this.set("offset", this.get("offset") + this.get("maxResults"));
    },

    onlyOffsetChanged: function () {
      return (this.changedAttributes() &&
             _.isEqual(_.keys(this.changedAttributes()), ["offset"]));
    },

    resetOffset: function () {
      if (!this.onlyOffsetChanged()) {
        this.set("offset", this.defaults.offset, { silent: true });
      }

      return this;
    },

    decreaseTotal: function () {
      return this.set("total", this.get("total") - this.get("maxResults"));
    },

    resetDefaults: function (options) {
      this.trigger("resetDefaults");
      return this.clear(options).set(this.defaults, options);
    },

    // TODO: Use a collection instead?

    add: function (attr, value) {
      var ary = _.clone(this.get(attr)) || [];
      ary.push(value);
      this.set(attr, ary);
      return this;
    },

    remove: function (attr, value) {
      var ary = _.without(this.get(attr), value);

      if (ary.length) {
        this.set(attr, ary);
      } else {
        this.unset(attr);
      }

      return this;
    },

    update: function (attr, value) {
      if (this.has(attr) && _.include(this.get(attr), value)) {
        this.remove(attr, value);
      } else {
        this.add(attr, value);
      }

      return this;
    }
  });
});

